import http from '../utils/fetch';
export default {
    sendEmail(email) {
        return http({
            url: 'api/resetpass/sendEmail',
            method: 'post',
            params: {email}
        });
    },
    checkResetpassUrl(id,ucode) {
        return http({
            url: 'api/resetpass/checkResetpassUrl',
            method: 'post',
            params: {id,ucode}
        });
    },
    updateUserPass(id,ucode,pass) {
        return http({
            url: 'api/resetpass/updateUserPass',
            method: 'post',
            params: {id,ucode,pass}
        });
    },
    resetUserPass(oldPassword,ucode,password) {
        return http({
            url: 'api/resetpass/resetUserPass',
            method: 'post',
            params: {oldPassword,ucode,password}
        });
    }
}